import { useContext, useState } from "react";
import { ReactComponent as Visibility } from "../../../../assets/img/icon/visibility_black_24dp.svg";
import { ReactComponent as VisibilityOff } from "../../../../assets/img/icon/visibility_off_black_24dp.svg";
import { linkDevice } from "../../../../services/httpService/deviceRequest";
import { deviceLinkValidator } from "../../../../validators/DeviceValidator";
import { GlobalContext } from "../../../contexts/globalContext";
import InputText from "../../atoms/InputText/InputText";
import Modal from "../../atoms/Modal/Modal";

const ModalDeviceLink = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [state, setState] = useState({
    _id: "",
    token: "",
    isHidden: true,
  });

  const handleChange = (e) => {
    let { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const generateErrorMessage = (error) => {
    let message;
    switch (error.message) {
      case "device was not found":
        message = "Perangkat tidak ditemukan";
        break;
      case "invalid token":
        message = "Token tidak valid.";
        break;
      default:
        message = error.message;
        break;
    }
    return message;
  };

  const handleClose = () => {
    setState({
      _id: "",
      token: "",
      isHidden: true,
    });
    if (props.handleClose) props.handleClose();
  };

  const handleSubmit = async () => {
    try {
      const { error } = await deviceLinkValidator({
        _id: state._id,
        token: state.token,
      });
      if (error) throw new Error(error.details[0].message);
      dispatch("isLoading", true);
      setState((prevState) => ({ ...prevState, isHidden: true }));
      await linkDevice({
        _id: state._id,
        token: state.token,
        action: "link",
      });

      dispatch("isLoading", false);
      handleClose();
      props.handleUpdate();
    } catch (error) {
      const message = generateErrorMessage(error);
      dispatch("alert", {
        type: "warning",
        message: message,
        show: true,
      });
      dispatch("isLoading", false);
    }
  };

  return (
    <Modal
      show={props.show}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      submitLabel="Tambahkan"
    >
      <div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Nama Perangkat</div>
          <InputText
            className="col-span-12 sm:col-span-9"
            onChange={handleChange}
            value={state._id}
            autoComplete="new-password"
            placeholder="Nama Perangkat"
            name="_id"
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Token</div>
          <div className="col-span-12 sm:col-span-9 relative">
            {state.isHidden ? (
              <VisibilityOff
                className="cursor-pointer absolute top-0.5 md:top-1 right-2 fill-current text-primary"
                onClick={() => {
                  setState((prevState) => ({ ...prevState, isHidden: false }));
                }}
              />
            ) : (
              <Visibility
                className="cursor-pointer absolute top-0.5 md:top-1 right-2 fill-current text-primary"
                onClick={() => {
                  setState((prevState) => ({ ...prevState, isHidden: true }));
                }}
              />
            )}
            <InputText
              type={state.isHidden ? "password" : "text"}
              onChange={handleChange}
              value={state.token}
              name="token"
              autoComplete="new-password"
              placeholder="Token"
            />
          </div>
        </div>

        <div className="bg-gray-200 mt-5 px-2 py-1 rounded-lg">
          <span className="font-semibold">Catatan </span> : Informasi nama
          perangkat dan token bisa anda peroleh dari box pembelian respinos.
        </div>
      </div>
    </Modal>
  );
};

export default ModalDeviceLink;
